import { useEffect, useState, useRef } from 'react';
import { Facet } from '../shared/Facet';
import { SUPPLIER_SEARCH_FILTER_TOOLTIP } from '../shared/AppConstants';
import { Autocomplete, Box, CircularProgress, TextField, Tooltip } from '@mui/material';
import { searchSuppliersByQuery } from '../shared/APIHelper';

export default function SupplierFilter(props) {
  const { setStatusErrorMsg, setParentFilter } = props.commonProps;
  const { setSelectedSuppliers, selectedSuppliers } = props;
  const [suppliers, setSuppliers] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState(null);
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const supplierSearchSeq = useRef(0);

  const onChange = (inputValue) => {
    // whole object of selected option
    processSuppliers(inputValue);
    setParentFilter && setParentFilter({ supplierFilter: inputValue });
  };

  function processSuppliers(selectedSuppliers) {
    let itemLabel = [];
    let suppliersList = '';

    selectedSuppliers &&
      selectedSuppliers.forEach((supplier) => {
        itemLabel.push({ parent: supplier.label });
        suppliersList +=
          suppliersList === '' ? supplier.value : ',' + supplier.value;
      });
    setSuppliers(selectedSuppliers || []);
    setSelectedLabels(itemLabel);
    setSelectedSuppliers(suppliersList);
  }

  const handleInputChange = async (_, inputValue) => {
    const seq = ++supplierSearchSeq.current;
    if (inputValue.length > 2) {
      setLoading(true);
      try {
        const results = await searchSuppliersByQuery(inputValue);
        if (seq !== supplierSearchSeq.current) return;
        setOptions(
          results.map((item) => ({
            value: item.supplierNumber,
            label: `${item.supplierNumber} - ${item.supplierName}`
          }))
        );
      } catch (error) {
        if (seq !== supplierSearchSeq.current) return;
        setStatusErrorMsg("Couldn't fetch Suppliers.", error);
      } finally {
        if (seq === supplierSearchSeq.current) {
          setLoading(false);
        }
      }
    } else {
      setOptions([]);
    }
  };
  useEffect(() => {
    processSuppliers(selectedSuppliers);
  }, [selectedSuppliers]);

  const removeSupplierSelection = (row) => {
    const updated = (suppliers ?? []).filter(
      (supplier) => supplier.label !== row.label
    );

    onChange(updated);
  };

  return (
    <Facet defaultActiveKey="supplier_filter">
      <Facet.Item
        id="supplier_filter"
        title="Strategic Supplier"
        openByDefault={true}
        selectedItems={selectedLabels}
        clearSelection={() => {
          setParentFilter && setParentFilter({ supplierFilter: [] });
          setSelectedSuppliers(null);
          setSuppliers(null);
          setSelectedLabels(null);
        }}
        onRemoveItem={removeSupplierSelection}
        toolTip={
          <Tooltip
            title={SUPPLIER_SEARCH_FILTER_TOOLTIP}
            placement={'top-start'}
          >
            <Box component="span" data-testid="info-icon" style={{ fontSize: '1rem', display: 'inline-flex' }}>
        <fuel-icon name="info_outlined" />
      </Box>
          </Tooltip>
        }
      >
        <Autocomplete
          multiple
          fullWidth
          options={options}
          value={suppliers ?? []}
          getOptionLabel={(option) => option.label ?? ''}
          isOptionEqualToValue={(option, value) => option.value === value?.value}
          filterOptions={(x) => x}
          loading={loading}
          onInputChange={handleInputChange}
          onChange={(_, values) => onChange(values)}
          renderTags={() => null}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              placeholder="Search by Name or Number (3+ characters)"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress color="inherit" size={16} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                )
              }}
            />
          )}
        />
      </Facet.Item>
    </Facet>
  );
}
